import { get, put } from "../web.request";

export const GetAppSettings = async (platform = "android") => {
  return await get(`/appSettings?platform=${platform}`);
};

export const UpdateAppSettings = async (data) => {
  return await put(`/appSettings`, data);
};
